import { PaymentMethod } from './';

export class ReceivePaymentModel {
    public clientUserId: string;
    public amount: number;
    public paymentMethod: PaymentMethod;
}
